import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { Select, MenuItem } from '@mui/material'

const ActiveSelectField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  let selectClass = ''

  if (isSubmitted) {
    selectClass = error ? 'input-error' : 'input-success'
  }

  const inputStyle = field.input_design ? { ...field.input_design } : {}

  // Si VALUE__reponse est présent, utilisez-le, sinon utilisez la première option par défaut
  const defaultValue = field.VALUE__reponse || ''

  const SelectRender = React.forwardRef(({ onChange, value }, ref) => (
    <Select
      ref={ref}
      style={inputStyle}
      value={value}
      onChange={onChange}
      className={`customSelect ${selectClass}`}
      defaultValue={defaultValue}
    >
      {field.options && field.options.length > 0 ? (
        field.options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No options available</MenuItem>
      )}
    </Select>
  ))

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field }) => <SelectRender {...field} />}
      defaultValue={defaultValue}
    />
  )
}

const InactiveSelectField = ({ field }) => {
  const inputStyle = field.input_design ? { ...field.input_design } : {}
  const defaultValue =
    field.options && field.options.length > 0 ? field.options[0].value : ''

  const SelectRender = () => (
    <Select
      style={inputStyle}
      className="customSelect"
      defaultValue={defaultValue}
    >
      {field.options && field.options.length > 0 ? (
        field.options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No options available</MenuItem>
      )}
    </Select>
  )

  return <SelectRender />
}

const SelectField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveSelectField field={field} control={control} />
  ) : (
    <InactiveSelectField field={field} />
  )
}

export default SelectField
